function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4545 18.9165C22.0759 17.9274 22.4365 16.7579 22.4365 15.5035C22.4365 11.9543 19.5593 9.07703 16.01 9.07703C12.4608 9.07703 9.5835 11.9543 9.5835 15.5035C9.5835 19.0528 12.4608 21.9301 16.01 21.9301C17.3649 21.9301 18.6212 21.5098 19.6575 20.7938L22.9168 22.067L21.4545 18.9165ZM16.01 19.7143C15.4251 19.7143 14.951 19.2401 14.951 18.6552C14.951 18.0703 15.4251 17.5961 16.01 17.5961C16.5949 17.5961 17.0691 18.0703 17.0691 18.6552C17.0691 19.2401 16.5949 19.7143 16.01 19.7143ZM16.01 16.8114C15.2104 16.8114 14.5561 11.9487 14.5561 11.9487C14.5561 11.6717 15.2104 11.4451 16.01 11.4451C16.8096 11.4451 17.4639 11.6717 17.4639 11.9487C17.4639 11.9487 16.8096 16.8114 16.01 16.8114Z",
  fill: "black"
});

var SvgReport = function SvgReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.63867 3.11222C10.1876 1.40906 13.1844 0.5 16.25 0.5C20.3609 0.5 24.3033 2.13303 27.2102 5.03984C30.117 7.94666 31.75 11.8891 31.75 16C31.75 19.0656 30.8409 22.0624 29.1378 24.6113C27.4346 27.1603 25.0138 29.147 22.1816 30.3201C19.3493 31.4933 16.2328 31.8002 13.2261 31.2022C10.2194 30.6041 7.45756 29.1279 5.28985 26.9601C3.12214 24.7924 1.64591 22.0306 1.04784 19.0239C0.449765 16.0172 0.756716 12.9007 1.92987 10.0684C3.10303 7.23615 5.0897 4.81538 7.63867 3.11222Z",
    fill: "#FAFAFA",
    style: {
      stroke: "var(--color-primary)"
    },
    strokeMiterlimit: 10
  }), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report.a76b450d.svg";
export { ForwardRef as ReactComponent };